import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, BookOpen, Heart, Shield, User, MapPin } from 'lucide-react';

interface NavigationProps {
  variant?: 'mobile' | 'desktop';
}

const Navigation: React.FC<NavigationProps> = ({ variant = 'mobile' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };
  
  const navItems = [
    { path: '/dashboard', label: 'Home', icon: Home },
    { path: '/journal', label: 'Journal', icon: BookOpen },
    { path: '/avatar', label: 'Companion', icon: Heart },
    { path: '/crisis', label: 'Support', icon: Shield },
    { path: '/profile', label: 'Profile', icon: User }
  ];

  if (variant === 'desktop') {
    return (
      <nav className="hidden md:flex items-center space-x-6">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
              isActive(item.path)
                ? 'bg-teal-100 text-teal-700'
                : 'text-slate-600 hover:text-teal-600 hover:bg-teal-50'
            }`}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
        
        {/* Add Resources link to desktop navigation */}
        <button
          onClick={() => navigate('/resources')}
          className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
            isActive('/resources')
              ? 'bg-teal-100 text-teal-700'
              : 'text-slate-600 hover:text-teal-600 hover:bg-teal-50'
          }`}
        >
          <MapPin className="w-5 h-5" />
          <span className="font-medium">Resources</span>
        </button>
      </nav>
    );
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-40 md:hidden">
      <div className="flex justify-around items-center">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center gap-1 py-3 px-4 w-full ${
              isActive(item.path)
                ? 'text-teal-600'
                : 'text-slate-500 hover:text-slate-900'
            }`}
          >
            <item.icon className="w-5 h-5" />
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;